import classNames from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useTimer } from 'react-timer-hook'

import { useGetBarcodeQuery } from '@shared/generated'
import Button from '@shared/ui/button'
import QrCode from '@shared/ui/qrcode'
import { copyText } from '@shared/uttils'

import styles from './styles.module.scss'


interface IModalBonusProps {
  card: string | null | undefined;
}
export default function ModalBonus ({ card }: IModalBonusProps) {
  const { data: { getBarcode } = {}, refetch } = useGetBarcodeQuery()
  const { t: tn } = useTranslation('personal')
  const [ isCopied, setIsCopied ] = useState(false)

  const { restart } = useTimer({
    expiryTimestamp: new Date(), 
    autoStart: false,
    onExpire: () => setIsCopied(false),
  })

  if (!card) {
    return null
  }

  const handleCopy = () => {
    setIsCopied(true)

    copyText(card)

    const time = new Date()
    // Устанавливаем новый таймер на 2 секунды
    time.setSeconds(time.getSeconds() + 2)
    restart(time)
  }

  return (
    <div className={styles.root}>
      {getBarcode?.code ? (
        <QrCode
          className={styles.root__qr}
          value={getBarcode.code}
          size={262}
        />
      ) : (
        <p>{tn('qrModal.pendingText')}...</p>
      )}
      <div className={styles.root__content}>
        <span className={styles.root__text}>{tn('qrModal.title')}</span>
        <span className={styles.root__number}>№ {card}</span>
        <button
          type="button"
          className={classNames('reset-button', styles.root__copy)}
        >
          <ReactSVG src="/icons/copy.svg" onClick={handleCopy} />
          {isCopied && (
            <p className={styles.root__copied}>{tn('qrModal.copied')}</p>
          )}
        </button>
        <Button
          className={styles.root__button}
          theme="secondary"
          onClick={() => refetch()}
        >
          <ReactSVG src="/icons/refresh.svg" />
          {tn('qrModal.buttonText')}
        </Button>
      </div>
    </div>
  )
}